import React from 'react';

import { Hyperlink, InputLabel } from 'ui';

interface CustomHyperlinkProps {
  url: string;
  label: string;
  linkCopy?: string;
  target?: string;
  rel?: string;
}

export const CustomHyperlink: React.FC<CustomHyperlinkProps> = ({ url, linkCopy, label }) => {
  return (
    <>
      <InputLabel label={label} name={label} />
      <Hyperlink url={url} label={linkCopy} newTab />
    </>
  );
};
